module.exports = __webpack_public_path__ + "img/Presentation39.5aa2efaa.png";